import { ENDPOINTS } from 'config/endpoints';
import { useMutation } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';

export default function useLogout() {
  const logout = () => {
    const request: Request = {
      url: ENDPOINTS.auth.logout,
      config: {
        method: 'get',
      },
    };

    return client(request);
  };

  const { isSuccess, isError, mutate, ...rest } = useMutation<
    Response<null>,
    CronoError,
    void
  >(logout, {
    meta: { silentError: true },
  });

  return { isSuccess, isError, mutate, ...rest };
}
